import { FunctionComponent, memo } from "react";
import { IProps } from "./client-details.types";
import { useClient } from "hooks-for/clients/use-client";
import { SpinnerUntil } from "@edgetier/components";
import { IClient } from "@edgetier/watchtower-types";
import "./client-details.scss";

/**
 * Display client name in navigation
 */
const ClientDetails: FunctionComponent<IProps> = ({ clientId }) => {
    const { data: client, isLoading } = useClient(clientId);
    return (
        <SpinnerUntil<IClient> data={client} isReady={!isLoading}>
            {(data) => (
                <li className="navigation-link client-details">
                    <div className="navigation-link__inner">
                        <div>{data.client}</div>
                    </div>
                </li>
            )}
        </SpinnerUntil>
    );
};

export default memo(ClientDetails);
